import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eec004a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "align-center l-font-size" }, "Введите новый пароль")
], -1))

import { computed, Ref, ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { helpers, required, sameAs } from '@vuelidate/validators';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { ErrorsType, ValidateRulesType } from '@/types';
import { changePasswordApi } from '@/api/login';

type FormDataType = {
  newPassword: string | undefined;
  confirmPassword: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const formData: Ref<FormDataType> = ref({
  newPassword: undefined,
  confirmPassword: undefined,
});
const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};

const passwordRule = helpers.regex(/(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])/);
const rules: ValidateRulesType = {
  newPassword: { required, passwordRule },
  confirmPassword: {
    required,
    sameAsPassword: sameAs(
      computed(() => {
        return formData.value.newPassword;
      }),
    ),
  },
};
const v$ = useVuelidate<FormDataType>(rules, formData);

const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};
const loading = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  loading.value = true;

  try {
    const res = await changePasswordApi(formData.value);

    if (res) {
      clearFormData();
      emit('close');
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_base_form, { class: "grid--1 gap--15" }, {
      default: _withCtx(() => [
        _createVNode(_component_base_input, {
          modelValue: formData.value.newPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.newPassword) = $event)),
          error: errors.value.newPassword,
          invalid: !!errors.value.newPassword,
          height: "40",
          label: "Пароль",
          type: "password",
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('password'))),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.newPassword)),
          onInput: _unref(v$).newPassword.$touch
        }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
        _createVNode(_component_base_input, {
          modelValue: formData.value.confirmPassword,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.confirmPassword) = $event)),
          error: errors.value.confirmPassword,
          invalid: !!errors.value.confirmPassword,
          height: "40",
          label: "Повторите пароль",
          type: "password",
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('password_confirmation'))),
          onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.confirmPassword)),
          onInput: _unref(v$).confirmPassword.$touch
        }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
        _createVNode(_component_base_button, {
          loading: loading.value,
          allBlockWidth: "",
          height: "40",
          text: "Сменить пароль",
          onClick: formSubmit
        }, null, 8, ["loading"])
      ]),
      _: 1
    })
  ]))
}
}

})